import React from "react";
import CTAButton from "./CTAButton";

const FinalCTA = () => {
  return (
    <section className="section" style={{
      background: "radial-gradient(700px 300px at 50% 50%, rgba(245,196,0,0.18), transparent 60%), #000",
      textAlign: "center",
    }}>
      <div className="container" style={{ maxWidth: 800 }}>
        <h2 className="h-title">
          Pronto para <span className="yellow">mudar sua história</span>?
        </h2>
        <p style={{ marginTop: 22, color: "rgba(255,255,255,0.8)", fontSize: 17, lineHeight: 1.7 }}>
          Entre para a comunidade que mais cresce no TikTok Shop brasileiro e comece com uma estrutura que funciona.
        </p>
        <div style={{ marginTop: 32, display: "flex", justifyContent: "center" }}>
          <CTAButton label="QUERO APLICAR O MÉTODO VSA" />
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
